/**
 * @namespace P3.math
 */
export {default as Color} from "./Color";
export {default as Vector2} from "./Vector2";

/**
 * Returns a random number within a range.
 *
 * @param {number} min - The minimum value (inclusive).
 * @param {number} max - The maximum value (exclusive).
 * @returns {number}
 */
export function random(min, max) {
    return Math.random() * (max - min) + min;
}

/**
 * Returns a random integer within a range.
 *
 * @param {number} min - The minimum value (inclusive).
 * @param {number} max - The minimum value (inclusive).
 * @returns {number}
 */
export function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Returns a random boolean.
 *
 * @returns {boolean}
 */
export function randomBool() {
    return Math.random() < 0.5;
}

/**
 * Return -1 or 1.
 *
 * @returns {number}
 */
export function randomSign() {
    return randomInt(0, 1) * 2 - 1;
}

/**
 * Rounds a value to a number of decimal places.
 *
 * @param {number} n - The value to round.
 * @param {number} [decimalPlaces=0] - The number of decimal places to round this number to.
 * @returns {number}
 */
export function roundNum(n, decimalPlaces = 0) {
    const decimals = Math.pow(10, decimalPlaces);
    return Math.round(Math.floor(n * decimals) / decimals);
}

/**
 * Return the sign of the given number.
 *
 * @param {number} n
 * @deprecated
 */
export function sign(n) {
    console.warn("Deprecation Warning: Please use 'Math.sign' instead of 'P3.math.sign'.");
    return Math.sign(n);
}

/**
 * Clamps a value to a range.
 *
 * @param {number} n
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export function clamp(n, min, max) {
    if (n < min) {
        n = min;
    } else if (n > max) {
        n = max;
    }
    return n;
}

/**
 * Linearly interpolate between two values.
 *
 * @param {number} a
 * @param {number} b
 * @param {number} t
 */
export function lerp(a, b, t) {
    return a + (b - a) * t;
}

/**
 * https://gist.github.com/wteuber/6241786
 *
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */
export function fmod(a, b) {
    return Number((a - (Math.floor(a / b) * b)).toPrecision(8));
}